import 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import * as colors from '@/theme/colors';

import { NotificationStylesProps } from '../types/Notifications.types';

const TOAST_ICON_SIZE = 24;

const toastBase = {
  borderRadius: 4,
  border: '1.5px solid',
  color: colors.darkBlue900,
  fontWeight: 500,
  width: 364,
  // container's right offset + padding, so the toast never overflows narrow viewports
  maxWidth: 'calc(100vw - 48px)',
  padding: 23,
  boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.10), 0 1px 5px 0 rgba(0, 0, 0, 0.05)',
} as const;

export const useNotificationStyles = makeStyles(() => ({
  containerRoot: {
    bottom: 32,
    right: 32,
    padding: 8,
    maxHeight: ({ topOffset }: NotificationStylesProps) => `calc(100vh - 32px - ${topOffset}px)`,
    overflowY: 'auto',
    overflowX: 'hidden',
    '&&::-webkit-scrollbar': { display: 'block', width: 8, height: 8 },
    '&&::-webkit-scrollbar-track': { background: 'transparent' },
    '&&::-webkit-scrollbar-thumb': { backgroundColor: `${colors.darkBlue900}33`, borderRadius: 4 },
    // Firefox-only styles as Firefox ignores ::-webkit-scrollbar;
    '@supports (-moz-appearance: none)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${colors.darkBlue900}33 transparent`,
    },
    // to prevent toasts from getting squashed instead of overflowing into a scroll
    '& > *': { flexShrink: 0 },
    '& .MuiSnackbarContent-root': {
      alignItems: 'flex-start',
      flexWrap: 'nowrap',
    },
    '& .MuiSnackbarContent-message': {
      flex: 1,
      minWidth: 0,
      padding: 0,
      whiteSpace: 'pre-line',
    },
    '& .MuiSnackbarContent-action': {
      marginRight: 0,
    },
    '& .MuiIconButton-root': {
      padding: 0,
      margin: 0,
    },
  },
  toastMessage: { alignItems: 'flex-start' },
  toastIcon: {
    flexShrink: 0,
    width: TOAST_ICON_SIZE,
    height: TOAST_ICON_SIZE,
    marginRight: 16,
  },
  successIcon: { color: colors.ideGreen600 },
  errorIcon: { color: colors.ideRed400 },
  infoIcon: { color: colors.blue900 },
  success: {
    ...toastBase,
    backgroundColor: colors.ideGreen100,
    borderColor: colors.ideGreen600,
  },
  error: {
    ...toastBase,
    backgroundColor: colors.ideRed100,
    borderColor: colors.ideRed400,
  },
  info: {
    ...toastBase,
    backgroundColor: colors.ideBlue100,
    borderColor: colors.blue900,
  },
  infoPrivacy: {
    backgroundColor: colors.white,
    maxWidth: 350,
    '& .MuiSvgIcon-root': {
      display: 'none',
    },
    '& .MuiSnackbarContent-message': {
      padding: 0,
      whiteSpace: 'initial',
    },
  },
}));
